import { useEffect, useState } from 'react';

export function useToast(duration = 2400) {
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!message) return undefined;
    const timer = window.setTimeout(() => setMessage(''), duration);
    return () => window.clearTimeout(timer);
  }, [message, duration]);

  return { message, showToast: setMessage };
}

interface ToastProps {
  message: string;
}

export function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-8 z-[60] flex justify-center px-4">
      <div className="hs-fade-up flex items-center gap-2 rounded-full border border-background-200/70 bg-background-200/95 px-5 py-3 text-sm font-medium text-foreground-950 backdrop-blur-md">
        <i className="ri-checkbox-circle-fill text-primary-500"></i>
        {message}
      </div>
    </div>
  );
}